import React from 'react';

function Dashboard({ teamCount, eventsCount, charityCount, onNavigate }) {
  const cards = [
    {
      id: 'team',
      title: 'Team Members',
      count: teamCount,
      subtitle: 'Founders, directors, advisors & members',
      icon: '',
      iconClass: 'team'
    },
    {
      id: 'events',
      title: 'Events',
      count: eventsCount,
      subtitle: 'Upcoming and past events',
      icon: '',
      iconClass: 'events'
    },
    {
      id: 'charity',
      title: 'Charities',
      count: charityCount,
      subtitle: 'Supported charity partners',
      icon: '',
      iconClass: 'charity'
    },
    {
      id: 'statistics',
      title: 'Statistics',
      count: '-',
      subtitle: 'Homepage & charity stats',
      icon: '',
      iconClass: 'stats'
    }
  ];

  return (
    <div>
      <div className="dashboard-grid">
        {cards.map(card => (
          <div
            key={card.id}
            className="dashboard-card"
            onClick={() => onNavigate(card.id)}
          >
            <div className="dashboard-card-header">
              <div className={`dashboard-card-icon ${card.iconClass}`}>
                {card.icon}
              </div>
              <div className="dashboard-card-count">{card.count}</div>
            </div>
            <div className="dashboard-card-title">{card.title}</div>
            <div className="dashboard-card-subtitle">{card.subtitle}</div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div style={{ marginTop: '2rem' }}>
        <h3 style={{
          fontSize: '1rem',
          fontWeight: '600',
          color: 'var(--forest-700)',
          marginBottom: '1rem'
        }}>
          Quick Actions
        </h3>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button
            className="btn-editor btn-editor-primary"
            onClick={() => onNavigate('team')}
          >
            + Add Team Member
          </button>
          <button
            className="btn-editor btn-editor-primary"
            onClick={() => onNavigate('events')}
          >
            + Add Event
          </button>
          <button
            className="btn-editor btn-editor-secondary"
            onClick={() => onNavigate('statistics')}
          >
            Update Stats
          </button>
        </div>
      </div>

      {/* Help Section */}
      <div className="settings-section" style={{ marginTop: '2rem' }}>
        <h3 className="settings-title">Getting Started</h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1rem'
        }}>
          <div>
            <strong style={{ color: 'var(--forest-700)' }}>Team Members</strong>
            <p style={{ fontSize: '0.875rem', color: 'var(--forest-600)', marginTop: '0.25rem' }}>
              Add or edit team members. Changes appear on the Team page immediately.
            </p>
          </div>
          <div>
            <strong style={{ color: 'var(--forest-700)' }}>Events</strong>
            <p style={{ fontSize: '0.875rem', color: 'var(--forest-600)', marginTop: '0.25rem' }}>
              Create upcoming events with dates, descriptions, and links.
            </p>
          </div>
          <div>
            <strong style={{ color: 'var(--forest-700)' }}>Charity</strong>
            <p style={{ fontSize: '0.875rem', color: 'var(--forest-600)', marginTop: '0.25rem' }}>
              Manage charity partners and track fundraising totals.
            </p>
          </div>
          <div>
            <strong style={{ color: 'var(--forest-700)' }}>Statistics</strong>
            <p style={{ fontSize: '0.875rem', color: 'var(--forest-600)', marginTop: '0.25rem' }}>
              Update the numbers shown on the homepage and charity page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
